// @ts-nocheck
/* eslint-disable */

import React from 'react';
import ViewEntity from '../../components/CRUD/ViewEntity';

const ViewPassengersGroup = () => {
  return (
    <ViewEntity
      pageTitle="PassengersGroupInfo"
      fetchApiUrl="/api/v1/web_portal/fare_media_policy_capping/passengers_groups/:id"
      fetchApiMethod="GET"
      dataPath="data.data"
      additionalApis={[
        {
          name: 'assignmentsCount',
          url: (mainData) => `/api/v1/web_portal/fare_media_policy_capping/fare_media_policy_capping_statistics/passengers-groups/${mainData.passengers_groups_id}/discount-band-assignments-count`,
          method: 'GET',
          dataPath: 'data.data.discount_band_assignments_count'
        }
      ]}
      fields={[
        {
          name: 'name',
          labelKey: 'ArName',
          type: 'text',
        },
        {
          name: 'en_name',
          labelKey: 'EnName',
          type: 'text',
        },
        {
          name: 'description',
          labelKey: 'description',
          type: 'text',
        },
        {
          name: 'fare_media_count',
          labelKey: 'FareMediaCount',
          type: 'text',
        },
        {
          name: 'is_default',
          labelKey: 'IsDefault',
          type: 'custom',
          render: (data, additionalData, intl) =>
            data.is_default
              ? intl.formatMessage({ id: 'Yes' })
              : intl.formatMessage({ id: 'No' }),
        },
        {
          name: 'discount_band_assignments_count',
          labelKey: 'AssociatedDiscountBandAssignments',
          type: 'custom',
          render: (data, additionalData) => {
            return additionalData.assignmentsCount !== undefined ? additionalData.assignmentsCount : '-';
          }
        },
        {
          name: 'organisation_name',
          labelKey: 'Organisation',
          type: 'custom',
          render: (data, additionalData, intl) => {
            const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
            return currentLanguageCode === 'en-us'
              ? data.org_en_name
              : data.org_ar_name;
          },
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        },
        {
          name: 'created_by_username',
          labelKey: 'CreatedBy',
          type: 'text',
        },
        {
          name: 'updated_by_username',
          labelKey: 'UpdatedBy',
          type: 'text',
        }
      ]}
      editUrl="/fare-products/passengers-groups/:id/edit"
      deleteApiUrl="/api/v1/web_portal/fare_media_policy_capping/passengers_groups/:id"
      deleteApiMethod="DELETE"
      backUrl="/fare-products/passengers-groups"
      backButtonLabel="Back"
      buildTitle={(data, additionalData, intl) => {
        return data.name;
      }}
      buildDeleteConfirmMessage={(data, additionalData, currentLanguageCode, intl) => {
        return `${intl.formatMessage({ id: 'AreYouSureDeletePassengersGroup' })} ${data.name}?`;
      }}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="PassengersGroups"
      permissionSystem="fares"
    />
  );
};

export default ViewPassengersGroup;
